import { Outlet } from 'react-router-dom';
import { DefaultTemplate } from 'v3/shared/templates/DefaultTemplate';

export const SellersRankingPage = () => {
  return (
    <DefaultTemplate>
      <Outlet />
    </DefaultTemplate>
  );
};
